import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import {
    ICreateRepositoryRequest,
    ICreateRepositoryResponse,
    IDeleteRepositoryResponse,
    IGetRepositoryRequest,
    IGetRepositoryResponse,
    IUpdateRepositoryResponse,
    TUpdateRepositoryRequest
} from 'dto/repository.dto';
const rootPathName = 'deployments/repositories';

export class RepositoriesApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('repositories', options);
    }

    protected getRootPath(): string {
        return rootPathName;
    }

    public async createRepository(accountId: number, accountUuid: string, params: ICreateRepositoryRequest): Promise<ICreateRepositoryResponse> {
        return this.send<ICreateRepositoryResponse>(HTTP_METHOD.POST, this.getRequestOptionsWithAccountId(accountId, '', params, `accountUuid=${accountUuid}`));
    }

    public async getRepositories(accountId: number, accountUuid: string, params?: IGetRepositoryRequest): Promise<IGetRepositoryResponse> {
        return this.send<IGetRepositoryResponse>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(accountId, '', { accountUuid, ...params }));
    }

    public async updateRepository(accountId: number, uuid: string, params: TUpdateRepositoryRequest): Promise<IUpdateRepositoryResponse> {
        return this.send<IUpdateRepositoryResponse>(HTTP_METHOD.PUT, this.getRequestOptionsWithAccountId(accountId, uuid, params));
    }

    public async deleteRepository(accountId: number, uuid: string): Promise<IDeleteRepositoryResponse> {
        return this.send<IDeleteRepositoryResponse>(HTTP_METHOD.DELETE, this.getRequestOptionsWithAccountId(accountId, uuid));
    }
}
